import React from 'react';
import { Table } from 'antd';

const ReusableTable = ({ 
  columns, 
  data, 
  loading = false,
  pagination = false,
  rowKey = 'key',
  title,
  scroll,
  ...otherProps 
}) => {
  return (
    <>
      {title && (
        <h3 style={{ 
          marginBottom: '20px', 
          fontSize: '18px',
          fontWeight: '600',
          color: '#262626'
        }}>
          {title}
        </h3>
      )}
      <Table 
        columns={columns} 
        dataSource={data}
        loading={loading}
        rowKey={rowKey}
        pagination={pagination}
        scroll={scroll}
        style={{
          background: 'white'
        }}
        {...otherProps}
      />
   </>
  );
};

export default ReusableTable;